<!-- 采购收数据操作 -->
<template>
    <div>
        <subComponents ref="showSelectData"></subComponents>
        <purchaseReceiptTemplate ref="purchaseReceiptTemplate"></purchaseReceiptTemplate>
        <div>
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="tabHeight">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主要信息 -->
                                <div v-if="scope.index == 0">
                                    <!-- 采购验收主表单 -->
                                    <el-form class="baseForm" id="mainInfo" label-width="150px" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                                        <el-row v-if="dataActionBox.actionType != 2" v-show="isShow" ref="baseForm">
                                            <template v-for="(formOneValue, formOneKey) in scope.row.jurconfigform">
                                                <el-form-item :label="formOneValue.showField" :prop="formOneValue.entityField" :key="formOneKey"
                                                              :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []" v-if="formOneValue.isShow == 1">
                                                    <template>
                                                        <!-- 系统字段 -->
                                                        <div v-if="formOneValue.isReserved == 0">
                                                            <!-- 收货单号 -->
                                                            <el-tooltip v-if="formOneValue.fieldType == 'extract'" class="item"
                                                                        :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9"
                                                                        effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                                <el-input clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                                          @keyup.enter.native="openExComponents(formOneValue.extractId, formOneKey, formOneValue.entityField, formOneValue.nosetField)"
                                                                          :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 1">
                                                                    <el-button @click="openExComponents(formOneValue.extractId, formOneKey, formOneValue.entityField, formOneValue.nosetField)" slot="append"
                                                                               icon="el-icon-search" :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 1">
                                                                    </el-button>
                                                                </el-input>
                                                            </el-tooltip>
                                                            <df-date v-else-if="formOneValue.fieldType == 'date'" :isShowLong="false" v-model="sendDataInfo[formOneValue.entityField]" :isdisabled="true"></df-date>
                                                            <!-- 第二验收人 -->
                                                            <el-input clearable title="second" :disabled="formOneValue.isChange == 0" v-else-if="formOneValue.entityField == 'pscadSeccher'"
                                                                      v-model="sendDataInfo.pscadSeccherName" @focus="dialogFormVisible = true">
                                                            </el-input>
                                                            <el-input v-else :disabled="formOneValue.isChange == 0" v-model.trim="sendDataInfo[formOneValue.entityField]"></el-input>
                                                        </div>
                                                    </template>
                                                </el-form-item>
                                            </template>
                                        </el-row>
                                        <el-row v-if="dataActionBox.actionType == 2" v-show="isShow">
                                            <template v-for="(formOneValue, formOneKey) in scope.row.jurconfigform">
                                                <el-form-item :label="formOneValue.showField + ':'" :prop="formOneValue.entityField" :key="formOneKey"
                                                              :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []" v-if="formOneValue.isShow == 1">
                                                    <template>
                                                        <!-- 系统字段 -->
                                                        <div v-if="formOneValue.isReserved == 0">
                                                            <span v-if="formOneValue.isRift == 1">
                                                                <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                                                                sendDataInfo[formOneValue.entityField] }}</a>
                                                            </span>
                                                            <span v-else-if="formOneValue.entityField == 'pscadSeccher'">{{
                                                            sendDataInfo.pscadSeccherName }}</span>
                                                            <span v-else-if="formOneValue.fieldType == 'date'">
                                                                <span v-if="sendDataInfo[formOneValue.entityField]">
                                                                    {{
                                                                    $common.getLocalTime(sendDataInfo[formOneValue.entityField])
                                                                }}
                                                                </span>
                                                            </span>
                                                            <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                                        </div>
                                                    </template>
                                                </el-form-item>
                                            </template>
                                        </el-row>
                                    </el-form>
                                    <!-- 查询 -->
                                    <el-row id="operateBtn1">
                                        <el-col :span="21">
                                            <el-input v-model.trim="filterMsg" placeholder="请输入搜索信息" size="mini" style="width:200px"></el-input>
                                            <el-button type="primary" @click="searchClick" size="mini" style="margin-left:10px;">查询</el-button>
                                            <!-- <el-button type="primary" size="mini" @click="lookLicence()">查看证照</el-button> -->
                                            <el-button type="primary" size="mini" v-if="isShow" @click="tablesq">
                                                收起<i class="el-icon-arrow-up"></i></el-button>
                                            <el-button type="primary" size="mini" v-if="!isShow" @click="tablezk">
                                                展开<i class="el-icon-arrow-down"></i></el-button>
                                        </el-col>
                                    </el-row>
                                    <!-- 验收明细 -->
                                    <el-form :inline="true" size="mini">
                                        <el-table border style="width: 100%" :data="filterTableData" ref="mxTableRef" :key=tableKey :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent"
                                                  @selection-change="handleSelectionChange" @expand-change="openChild" size="mini" :height="mxHeight / 2">
                                            <!-- 明细信息 -->
                                            <template v-for="(formOneValue) in mxForm">
                                                <el-table-column align="center" :key="formOneValue.psrgmId" :prop="formOneValue.entityField" :label="formOneValue.showField" show-overflow-tooltip
                                                                 :min-width="formOneValue.fieldWeight" v-if="formOneValue.isShow == 1">
                                                    <template slot-scope="scope">
                                                        <!-- 显示通用名称 -->
                                                        <span v-if="formOneValue.isRift == 1">
                                                            <a @click="toDetail(filterTableData[scope.$index][formOneValue.riftField])">
                                                                {{ filterTableData[scope.$index][formOneValue.entityField]
                                                            }}</a>
                                                        </span>
                                                        <span v-else-if="formOneValue.fieldType == 'date'">
                                                            {{
                                                            $common.getLocalTime(filterTableData[scope.$index][formOneValue.entityField])
                                                        }}
                                                        </span>
                                                        <!-- 第二验收人 -->
                                                        <span v-else-if="formOneValue.entityField == 'pscadSeccher'">
                                                            {{ filterTableData[scope.$index].pscadSeccherName }}
                                                        </span>

                                                        <!-- 是否双人验收 -->
                                                        <el-tag size="mini" v-else-if="formOneValue.entityField == 'bgiIsdcheck'">
                                                            {{ filterTableData[scope.$index].bgiIsdcheck == 0 ? '否' : '是' }}
                                                        </el-tag>

                                                        <span v-else>
                                                            {{ filterTableData[scope.$index][formOneValue.entityField] }}
                                                        </span>
                                                    </template>
                                                </el-table-column>
                                            </template>
                                            <el-table-column align="center" label="上架状态" width="110" fixed="right">
                                                <template slot-scope="scope">
                                                    <el-link v-if="scope.row.checkState == 0" type="danger" :underline="false">未上架</el-link>
                                                    <el-link v-if="scope.row.checkState == 1" type="warning" :underline="false">部分上架</el-link>
                                                    <el-link v-if="scope.row.checkState == 2" type="success" :underline="false">全部上架</el-link>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </el-form>

                                    <div>
                                        <!-- 操作 -->
                                        <el-row v-if="dataActionBox.actionType != 2" id="operateBtn">
                                            <el-button type="primary" @click="addNewBatch" size="mini">添加明细</el-button>
                                            <el-button type="primary" @click="delOldBatch" size="mini">删除明细</el-button>
                                        </el-row>
                                        <el-table border class="baseTable" :data="pschacBatchDetails" size="mini" :height="mxHeight / 2" ref="pschacBatchDetails">
                                            <!-- 批号信息 pschacBatchDetails-->
                                            <el-table-column label="选择操作" width="90" v-if="dataActionBox.actionType != 2">
                                                <template slot-scope="scope">
                                                    <el-radio v-model="selectedBatchnoIndex" :label="scope.$index" border size="mini">
                                                        <i class="el-icon-thumb"></i>
                                                    </el-radio>
                                                </template>
                                            </el-table-column>

                                            <template v-for="(formOneValue, formOneKey) in phForm">
                                                <el-table-column align="center" :key="formOneKey" :min-width="formOneValue.fieldWeight" :prop="formOneValue.entityField" :label="formOneValue.showField"
                                                                 v-if="formOneValue.isShow == 1">
                                                    <template slot="header" slot-scope="scope">
                                                        <div class="item-top" style="display: flex;align-items: center;">
                                                            <p class="gray-txt">{{ formOneValue.showField }}</p>
                                                            <el-popover v-if="formOneValue.entityField == 'pscadSchnumber'" placement="top-start" title="抽检规则" width="200" trigger="hover" :content="popTitle">
                                                                <i slot="reference" class="el-icon-question" style="font-size: 16px" />
                                                            </el-popover>
                                                        </div>
                                                    </template>
                                                    <template slot-scope="scope">

                                                        <!-- 验收结论 -->
                                                        <el-select :disabled="dataActionBox.actionType == 2 || formOneValue.isChange == 0" v-if="formOneValue.entityField == 'pscadCheckcon'"
                                                                   @focus="setPhIndex(scope.$index, formOneValue.focusField)" :ref="formOneValue.entityField" :id="formOneValue.entityField" @visible-change="selectChange"
                                                                   v-model="pschacBatchDetails[scope.$index][formOneValue.entityField]">
                                                            <el-option v-for="(storageRoomValue, storageRoomKey) in ['合格', '不合格']" :key="storageRoomKey" :label="storageRoomValue" :value="storageRoomValue">
                                                            </el-option>
                                                        </el-select>
                                                        <el-select clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2"
                                                                   @change="$forceUpdate()" v-model="pschacBatchDetails[scope.$index][formOneValue.entityField]" placeholder="请选择">
                                                            <el-option v-for="(item, index) in JSON.parse(
                                                            formOneValue.formatterContent
                                                        )" :key="index" :label="item.key" :value="item.value">
                                                            </el-option>
                                                        </el-select>

                                                        <!-- 生产日期 -->
                                                        <df-date :isShowLong="formOneValue.entityField == 'expidate' ? true : false" v-else-if="formOneValue.fieldType == 'date' && dataActionBox.actionType != 2"
                                                                 :isdisabled="dataActionBox.actionType == 2 || formOneValue.isChange == 0" :ref="formOneValue.entityField" :class="formOneValue.entityField"
                                                                 :isLongTime="formOneValue.entityField == 'expidate' ? true : false"
                                                                 :isNull="formOneValue.entityField == 'expidate' || formOneValue.entityField == 'prodate' ? true : false"
                                                                 @focus="setPhIndex(scope.$index, formOneValue.focusField)" @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)"
                                                                 v-model="pschacBatchDetails[scope.$index][formOneValue.entityField]">
                                                        </df-date>

                                                        <!-- 不合格数量拒收 -->

                                                        <el-input v-else-if="formOneValue.entityField == 'listingNum'" @input="changeListingNum(scope.$index)"
                                                                  :disabled="dataActionBox.actionType == 2 || formOneValue.isChange == 0" :ref="formOneValue.entityField"
                                                                  @keyup.enter.native="tableNextFocus('slCode', scope.$index)" v-model="pschacBatchDetails[scope.$index][formOneValue.entityField]" type="number" :min="0"
                                                                  onkeyup="this.value=this.value.replace(/[^\d.]/g,'')"></el-input>
                                                        <el-input v-else-if="formOneValue.entityField == 'pscadRefnumber'" :disabled="dataActionBox.actionType == 2 || formOneValue.isChange == 0"
                                                                  :ref="formOneValue.entityField" @focus="setPhIndex(scope.$index, formOneValue.focusField)" @blur="queryCount(scope.$index)"
                                                                  @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" v-model.number="pschacBatchDetails[scope.$index][formOneValue.entityField]"
                                                                  type="number" :min="0" onkeyup="this.value=this.value.replace(/[^\d.]/g,'')"></el-input>
                                                        <!-- 验收合格数量 -->
                                                        <el-input v-else-if="formOneValue.entityField == 'pscadQuanumber'" :disabled="dataActionBox.actionType == 2 || formOneValue.isChange == 0"
                                                                  :ref="formOneValue.entityField" @focus="setPhIndex(scope.$index, formOneValue.focusField)"
                                                                  @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" v-model="pschacBatchDetails[scope.$index][formOneValue.entityField]"
                                                                  type="number" :min="0" onkeyup="this.value=this.value.replace(/[^\d.]/g,'')"></el-input>
                                                        <!-- 抽检数量 -->
                                                        <el-input v-else-if="formOneValue.entityField == 'pscadSchnumber'" :disabled="dataActionBox.actionType == 2 || formOneValue.isChange == 0"
                                                                  :ref="formOneValue.entityField" @focus="setPhIndex(scope.$index, formOneValue.focusField)"
                                                                  @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" v-model.number="pschacBatchDetails[scope.$index][formOneValue.entityField]"
                                                                  type="number" :min="0"></el-input>
                                                        <!-- 检索方案 -->
                                                        <el-input v-else-if="formOneValue.fieldType == 'search'" clearable v-model="pschacBatchDetails[scope.$index][formOneValue.entityField]"
                                                                  :ref="formOneValue.entityField" :id="formOneValue.entityField" @focus="setPhIndex(scope.$index, formOneValue.focusField)"
                                                                  @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField, formOneValue.focusField,true)"
                                                                  :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                            <el-button @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField, formOneValue.focusField,true)" slot="append"
                                                                       icon="el-icon-search" :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                            </el-button>
                                                        </el-input>
                                                        <span v-else-if="formOneValue.entityField == 'udiCode'">
                                                            {{ pschacBatchDetails[scope.$index][formOneValue.entityField] }}
                                                        </span>
                                                        <span v-else-if="formOneValue.fieldType == 'date' && dataActionBox.actionType == 2">
                                                            {{ $common.getLocalTime(scope.row[formOneValue.entityField]) }}
                                                        </span>
                                                        <el-input v-else :disabled="dataActionBox.actionType == 2 || formOneValue.isChange == 0" v-model="pschacBatchDetails[scope.$index][formOneValue.entityField]"
                                                                  :ref="formOneValue.entityField" @focus="setPhIndex(scope.$index, formOneValue.focusField)"
                                                                  @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :maxlength="$store.state.inputLength"></el-input>

                                                    </template>
                                                    <!--  @blur="isReq(scope.$index, formOneValue, pschacBatchDetails[scope.$index][formOneValue.entityField])" -->
                                                </el-table-column>
                                            </template>
                                        </el-table>
                                    </div>
                                </div>

                                <!-- 冷链信息 -->
                                <div v-if="scope.index == 1">
                                    <el-form size="mini" id="coldInfo" class="baseForm" label-width="150px" :show-message="false">
                                        <el-row>
                                            <template v-for="(formOneValue,formOneKey) in scope.row.jurconfigform">
                                                <el-form-item :key="formOneKey" :label="formOneValue.showField" v-if="formOneValue.isShow == 1"
                                                              :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                                    <el-input disabled v-model.trim="sendDataInfo[formOneValue.entityField]"></el-input>
                                                </el-form-item>
                                            </template>
                                        </el-row>
                                    </el-form>
                                </div>

                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <tree v-if="dataActionBox.actionType == 2" ref="tree" @tabHeight="(val) => { mxHeight = val }"></tree>
                <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :sendDataInfo="sendDataInfo" @initActionBox="cancelActionBox" @sendDataAction="sendDataAction" @showPrintPlan="showPrintPlan"></v-foot>

            </div>

        </div>

        <!-- 第二验收人 -->
        <el-dialog title="选择验收人并且输入验收人的密码" :visible.sync="dialogFormVisible" :append-to-body="true" :close-on-click-modal="false">
            <el-form label-position="top">
                <el-form-item label="账户">
                    <el-input v-model="reviewUserInfo.selectIndex"></el-input>
                </el-form-item>
                <el-form-item label="密码">
                    <el-input type="password" v-model="reviewUserInfo.passWord"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="userVerification()">确 定</el-button>
            </div>
        </el-dialog>

        <!-- new明细提取 -->
        <el-dialog :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :width="exWidth" :modal-append-to-body='true' :append-to-body="true">
            <ExtractionScheme ref="extractionScheme" :id="exId" :ppId="ppId" @TranData="getTiqu" @getWidth="getWidth" @sendTitle="getExtractName" />
        </el-dialog>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
    </div>
</template>
  
<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import ExtractionScheme from "../byComponents/ExtractionScheme.vue";
import SearchScheme from "../byComponents/SearchScheme.vue";
import purchaseReceiptTemplate from "@/components/purchaseReceiptTemplate.vue";
export default {
    name: "salesUpListAction",
    props: ["actionData"],
    //import引入的组件需要注入到对象中才能使用
    components: {
        ExtractionScheme,
        SearchScheme,
        purchaseReceiptTemplate
    },
    data() {
        //这里存放数据
        return {
            isShow: true,
            phHeight: 300,
            detailRules1: false, //抽检拦截
            detailRules2: false, //第二验收人拦截
            separateDialog: false,
            exTitle: "",
            DialogExtract: false,
            exWidth: "",
            exId: "",
            ppId: "",
            rowindex: 0,
            childindex: 0,
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {},
            showTabs: "",
            formDataList: [],
            userOneList: [],
            userTwoList: [], // 验收人
            reviewUserInfo: {
                opmId: "",
                passWord: "",
                selectIndex: '',
            },
            msgDialogVisible: false, //批号
            pschacBatchDetails: [], //批号项
            pschacBatchDetailsObj: {},//初始批号对象
            dialogFormVisible: false, //第二验收
            actionIndex: "",
            storageRoomList: [],
            ishowRew: true,
            // detailsAction:[],
            reviewDetailsData: {},
            msgTabsActive: "addMsg", //明细二级name
            filterMsg: "", //搜索信息
            filterTableData: [], //搜索缓存明细
            bachDialogTitle: {}, //批号弹窗头信息
            selectedBatchnoIndex: 0, //批号选择
            isLoaded: false,
            mxHeight: 0,
            tabForm: [], // 主表单
            mxForm: [], // 明细表单
            footForm: [], //表尾
            phForm: [], // 批号明细
            seTitle: "", //检索
            DialogVisible: false,
            seId: 0,
            seType: "",
            seIndex: 0,
            seWidth: "",
            sField: "",
            fField: "",
            parentSearchData: {},
            inputel: "",
            phIndex: 0,
            popTitle: '',
            selectedRow: [], // 当前已选择行
            selectedDetailsIndex: 0,
            keydownField: '',
            tableIndex: 0,
            newTime: '',
            newDayTime: '',
            flag: false,
            udiCode: "",
            tableKey: 0,
            detailsFlag:false
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        filterMsg() {
            //搜索
            this.searchClick();
        },
        "pschacBatchDetails": {
            handler: function (newval, oldval) {
                this.filterTableData[this.selectedDetailsIndex].detailInfo = [...newval]
            },
            deep: true,
        },
        "selectedDetailsIndex": {
            handler: function (newValue, oldValue) {
                if (newValue != oldValue) addEventListener('keyup', this.keyUpEnter)//创建监听键盘事件
            },
            deep: true,
        },
    },
    //方法集合
    methods: {
        add(val) {

            for (const key in this.pschacBatchDetails[this.selectedBatchnoIndex]) {
                if (val[key] != undefined) {
                    this.pschacBatchDetails[this.selectedBatchnoIndex][key] = val[key]
                }
            }

        },
        tabHeight(val) {
            console.log(val);
        },
        async queryCount(index) {
        },
        getTimestamp() {
            this.newTime = this.$common.getEndTime()
            this.newDayTime = Number(this.$common.getNewDayTime() * 1 + 86400000)
        },
        closeChild() {
            addEventListener('keyup', this.keyUp)//创建监听键盘事件
        },
        sureUp() {
            const total = this.filterTableData[this.selectedDetailsIndex].detailInfo.reduce((prev, item) => {
                prev += +item.listingNum
                return prev
            }, 0)
            const totalnum = +this.filterTableData[this.selectedDetailsIndex].rgcadQuanumber + +this.filterTableData[this.selectedDetailsIndex].rgcadRefnumber
            console.log(total, totalnum);
            if (total == 0) {
                this.filterTableData[this.selectedDetailsIndex].checkState = 0
            } else if (total < totalnum) {
                this.filterTableData[this.selectedDetailsIndex].checkState = 1
                this.addPschacBatch()
            } else if (total > totalnum) {

                return this.$message.error('请填写合理的上架数量')
            } else {
                this.filterTableData[this.selectedDetailsIndex].checkState = 2
                // this.pschacBatchDetails[this.pschacBatchDetails-1]
                this.$refs['slCode'][this.pschacBatchDetails.length - 1].blur()
            }
            this.tableKey++
        },
        // 监听键盘事件
        keyUp(e) {
            e.preventDefault();
            if (e.keyCode == 40) { // 下键
                // 表格为空，不执行下方 
                if (this.filterTableData.length == 0) return
                let refsElTable = this.$refs.mxTableRef
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) { // 如果当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0
                    } else if (this.selectedDetailsIndex == this.filterTableData.length - 1) { // 如果选中的是最后一行了，那么下一行选中的是第一行
                        this.selectedDetailsIndex = 0
                    } else { // 正常递增
                        this.selectedDetailsIndex++
                    }
                    if (!refsElTable) return
                    let findRow = this.selectedRow.find(c => c.rowIndex == this.selectedDetailsIndex); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(this.filterTableData[this.selectedDetailsIndex], false);
                        return;
                    }
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.filterTableData[this.selectedDetailsIndex]); // 把现在当前行勾选
                })
            } else if (e.keyCode == 38) { // 上键
                if (this.filterTableData.length == 0) return
                let refsElTable = this.$refs.mxTableRef
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) { // 当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0
                    } else if (this.selectedDetailsIndex == 0) { // 如果选中的是第一行了，那么下一行选中的是最后一行
                        this.selectedDetailsIndex = this.filterTableData.length - 1
                    } else { // 正常递减
                        this.selectedDetailsIndex--
                    }
                    if (!refsElTable) return
                    let findRow = this.selectedRow.find(c => c.rowIndex == this.selectedDetailsIndex); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(this.filterTableData[this.selectedDetailsIndex], false);
                        return;
                    }
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.filterTableData[this.selectedDetailsIndex]); // 把现在当前行勾选
                })
            }
        },
        keyUpEnter(e) {
            e.preventDefault();
            if (e.keyCode == 13) {
                this.$nextTick(() => {
                    this.msgCellClick(this.filterTableData[this.selectedDetailsIndex])
                    removeEventListener('keyup', this.keyUpEnter)
                });
            }
        },

        // 表格方法
        rowClassName({ row, rowIndex }) {
            let rowName = "",
                findRow = this.selectedRow.find(c => c.rowIndex === row.rowIndex);
            if (findRow) {
                rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },

        // 选中行底色逻辑
        rowStyle({ row, rowIndex }) {
            Object.defineProperty(row, "rowIndex", { // 给每行添加不可枚举属性rowIndex来标识当前行
                value: rowIndex,
                writable: true,
                enumerable: false
            });
            let rowBackground = {}
            if (row.bgColor && row.bgColor != '') rowBackground.backgroundColor = row.bgColor
            return rowBackground
        },

        // 明细表格点击选中
        clickEvent(row, column, event, params) {
            console.log('点击明细', row)
            this.msgCellClick(row)
            let refsElTable = this.$refs.mxTableRef; // 获取表格对象
            let findRow = {}
            this.selectedDetailsIndex = row.rowIndex
            const info = { ...this.filterTableData[this.selectedDetailsIndex] }
            info.listingNum = +this.filterTableData[this.selectedDetailsIndex].rgcadQuanumber + +this.filterTableData[this.selectedDetailsIndex].rgcadRefnumber
            this.pschacBatchDetails = this.filterTableData[this.selectedDetailsIndex].detailInfo || [info]
            this.selectedBatchnoIndex = 0
            findRow = this.selectedRow.find(c => c.rowIndex == row.rowIndex); //找出当前选中行
            //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
            if (findRow && this.selectedRow.length === 1) {
                refsElTable.toggleRowSelection(row, false);
                return;
            }
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(row);

        },

        // 保存已选择行
        handleSelectionChange(rows) {
            this.selectedRow = rows; // 保存已选择行
        },
        tablesq() {
            this.isShow = false
            this.getHeight()
        },
        tablezk() {
            this.isShow = true
            this.getHeight()
        },
        setPhIndex(index, fField) {
            this.phIndex = index;
            this.fField = fField;
        },
        changeListingNum(index) {
            const totalNum = this.pschacBatchDetails.reduce((prev, item) => {
                prev += item.listingNum
                return prev
            }, 0)
            // if (+this.pschacBatchDetails[index].listingNum > +this.filterTableData[this.selectedDetailsIndex].rgcadRefnumber + +this.filterTableData[this.selectedDetailsIndex].rgcadQuanumber - totalNum) {
            //     this.pschacBatchDetails[index].listingNum = 0
            //     const number = +this.filterTableData[this.selectedDetailsIndex].rgcadRefnumber + +this.filterTableData[this.selectedDetailsIndex].rgcadQuanumber - totalNum
            //    console.log("aodmo1",totalNum,number);
            //     this.pschacBatchDetails[index].listingNum = number
            // }
            this.pschacBatchDetails[index].costAmount =
                this.$common.getDecimalInfo(3, NP.times(+this.pschacBatchDetails[index].costPrice, +this.pschacBatchDetails[index].listingNum));

            var money = this.$common.getDecimalInfo(3, NP.times(+this.pschacBatchDetails[index].price, +this.pschacBatchDetails[index].listingNum))
            var psMoney = this.$common.getDecimalInfo(3, NP.times(+this.pschacBatchDetails[index].psprice, +this.pschacBatchDetails[index].listingNum))
            this.pschacBatchDetails[index].money = money
            this.pschacBatchDetails[index].psmoney = psMoney

            this.pschacBatchDetails[index].costMoney = this.$common.getDecimalInfo(3, NP.times(+this.pschacBatchDetails[index].woadWcost, +this.pschacBatchDetails[index].listingNum))	//成本金额
            this.pschacBatchDetails[index].gross = this.$common.getDecimalInfo(3, NP.minus(NP.times(+this.pschacBatchDetails[index].psprice, +this.pschacBatchDetails[index].listingNum), NP.times(+this.pschacBatchDetails[index].woadWcost, +this.pschacBatchDetails[index].listingNum)))	//毛利
            // this.sendDataInfo.totalMoney=0
            // this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(3, NP.plus(+this.sendDataInfo.totalMoney, +psMoney))
            // this.sendDataInfo.totalNumber = this.$common.getDecimalInfo(1, NP.plus(+this.sendDataInfo.totalNumber,  +this.pschacBatchDetails[index].listingNum))
            // var midmoney = info.listingNum === 0 ? 0 : this.$common.getDecimalInfo(3, NP.times(info.psprice, info.listingNum));
            // var midmoney = info.listingNum === 0 ? 0 : this.$common.getDecimalInfo(3, NP.times(info.psprice, info.listingNum));
            // // var midmoney = info.listingNum === 0 ? 0 : NP.times(info.psprice, info.listingNum).toFixed(10);
            // this.pschacBatchDetails[index].psmoney = this.$common.getDecimalInfo(3, midmoney);
            // // 计算总金额 含税金额/(税率/100+1)
            // this.pschacBatchDetails[index].money = this.$common.getDecimalInfo(3, NP.divide(this.pschacBatchDetails[index].psmoney, NP.plus(NP.divide(info.inRate, 100), 1)));
            // // 计算整件数量
            // this.pschacBatchDetails[index].wholeNum = Math.floor(NP.divide(info.listingNum, Number(info.packingSpec)));
            // //计算零散数量
            // this.pschacBatchDetails[index].scatNum = NP.minus(info.listingNum, NP.times(this.pschacBatchDetails[index].wholeNum, Number(info.packingSpec)));
            // //计算税额
            // this.pschacBatchDetails[index].taxAmount = this.$common.getDecimalInfo(3, NP.minus(this.pschacBatchDetails[index].psmoney, this.pschacBatchDetails[index].money));

            // // 计算件数 采数/包装单位
            // if (parseFloat(info.packingSpec) <= 0 || info.packingSpec == "") {
            //   this.pschacBatchDetails[index].pieceNum = 0;
            // } else {
            //   this.pschacBatchDetails[index].pieceNum =
            //     this.$common.getDecimalInfo(
            //       1,
            //       NP.divide(info.listingNum, info.packingSpec)
            //     );
            // }
        },
        // 查看证照
        lookLicence() {
            if (this.sendDataInfo.smId == "") {
                return this.$message({
                    message: "请先选择供货单位",
                    type: "warning",
                });
            }
            this.$parent.$parent.toDetail(this.sendDataInfo.smId);
        },
        showPrintPlan() {
            // 打印方法
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(
                    this.actionData.orderId,
                    this.actionData.printSouce,
                    this.actionData.printJurId
                );
            } else {
                return;
            }
        },
        // 子组件穿透方法
        toDetail(orderId) {
            if (this.dataActionBox.actionType != 2)
                this.$parent.$parent.toDetail(orderId);
            else this.$parent.$parent.$parent.toDetail(orderId);
        },
        //明细二级表单展开
        openChild(row) {
            this.childindex = row.in; //
        },
        //明细操作弹窗
        async msgCellClick(row) {
            if (row == undefined) {
                return
            }
            this.pschacBatchDetails = row.detailInfo ? [...row.detailInfo] : []
            this.selectedBatchnoIndex = Number(this.pschacBatchDetails.length - 1)
            this.$nextTick(() => {
                if (this.pschacBatchDetails.length == 0) {
                    this.addPschacBatch()
                }
                removeEventListener('keyup', this.keyUpEnter)
                // this.tableNextFocus("batchno", 0);
            });
        },
        //查询
        searchClick() {
            if (this.filterMsg) {
                this.filterTableData = this.sendDataInfo.pschaDetails.filter((data) =>
                    data.bgmName.toLowerCase().includes(this.filterMsg.toLowerCase())
                );
            } else {
                this.filterTableData = this.sendDataInfo.pschaDetails;
            }
        },
        //提取明细信息
        async getTiqu(val) {
            console.log("提回", JSON.parse(JSON.stringify(val)));
            let obj = val;
            this.DialogExtract = false;
            if (val && val != null) {
                for (let key in obj) {
                    if (key == "arrlistbychen") continue;
                    this.sendDataInfo[key] = obj[key];
                }
                this.sendDataInfo.pschaDetails = obj.arrlistbychen;
                this.filterTableData = obj.arrlistbychen;
                this.filterTableData.forEach(item => {
                    item.checkState = 0
                })
                this.sendDataInfo.pschaDetails.forEach((v, i) => {
                    v.price = v.price ? this.$common.getDecimalInfo(2, v.price) : 0;
                    v.pscadRefnumber = v.pscadRefnumber ? this.$common.getDecimalInfo(2, v.pscadRefnumber) : 0;
                    v.money = v.money ? this.$common.getDecimalInfo(3, v.money) : 0;
                    v.psmoney = v.psmoney ? this.$common.getDecimalInfo(3, v.psmoney) : 0;
                    v.in = i;
                    v.checkState = 0
                    v.pschacBatchDetails = [];
                });


                if (this.sendDataInfo.pschaDetails.length > 0) this.msgCellClick(this.sendDataInfo.pschaDetails[0])
                this.$nextTick(() => {
                    this.tableNextFocus('listingNum', 0);
                    this.selectedDetailsIndex = 0
                    this.selectedBatchnoIndex = 0
                    let refsElTable = this.$refs.mxTableRef
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.filterTableData[this.selectedDetailsIndex]);
                });
                this.pschacBatchDetails = []
                this.addPschacBatch(); //重置批号数组
            }
        },
        // 提取方案
        openExComponents(e, index) {
            this.DialogExtract = true;
            this.seIndex = index;
            this.exId = e;
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getWidth(e) {
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        getExtractName(e) {
            this.exTitle = e;
        },
        //        检索Id, 索引， 字段名，赋值字段，焦点字段, 不可赋值字段
        openSearch(sId, index, type, sField, fField,flag) {
            this.detailsFlag=flag?true:false
            removeEventListener('keyup', this.keyUp)
            removeEventListener('keyup', this.keyUpEnter)
            this.DialogVisible = true;
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField;
            this.fField = fField;
            if (type == "bgiRegistno") {
                this.parentSearchData[type] = this.pschacBatchDetails[this.seIndex][type];
                this.parentSearchData['bgmId'] = this.sendDataInfo.pschaDetails[this.rowindex]['bgmId'];
            } else {
                this.parentSearchData[type] = this.pschacBatchDetails[type];
            }
            if (this.detailsFlag) {
                this.parentSearchData[type]=pschacBatchDetails[type]
            }
        },
        changeInputModel(val) {
            console.log('检索', val);
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                addEventListener('keyup', this.keyUp)
                this.paramValue(val);
            }
        },
        // 获取冷链表单所有input
        getMainInput() {
            var el = document.getElementById("mainInfo");
            this.inputel = el ? el.getElementsByTagName('input') : ''
        },
        // 初始化焦点
        initFocus() {
            for (let index = 0; index < this.inputel.length; index++) {
                if (this.inputel[index].value == "" && this.inputel[index].title != 'second') {
                    this.inputel[index].focus();
                    break;
                }
            }
        },
        // 批号表单select框切换enter切换焦点事件方法
        selectChange(e) {
            if (e == false) {
                this.tableNextFocus(this.fField, this.phIndex);
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                // this.pschacBatchDetails[this.seIndex][item] = val[item];
                this.$set(this.pschacBatchDetails[this.seIndex], item, val[item])
            });
            this.$nextTick(() => {
                this.pschacBatchDetails.splice(1, 0)
                this.sendDataInfo.pschaDetails[this.rowindex]["pschacBatchDetails"] = [...this.pschacBatchDetails]

                this.filterTableData[this.rowindex]["pschacBatchDetails"] = [...this.pschacBatchDetails]
                this.sendDataInfo.pschaDetails.splice(1, 0)
                this.filterTableData.splice(1, 0)
                if (this.seType == 'slCode') {
                    this.sureUp()
                }
                this.tableNextFocus(this.fField, this.seIndex);
            });
        },
        // 输入框切换焦点
        nextFocus(index) {
            if (index >= this.inputel.length - 1) {
                return;
            }
            var aindex = index + 1;
            if (this.inputel[aindex].title == 'second') {
                aindex += 1
            }
            if (this.inputel[aindex].value != "" || this.inputel[aindex].disabled) {
                this.nextFocus(aindex);
                return;
            }
            this.inputel[aindex].focus();
        },
        // 表格切换焦点方法
        tableNextFocus(field, index) {
            this.tableIndex = index
            if (field == "prodate") {
                let ine = document
                    .getElementsByClassName("prodate")[index].getElementsByTagName("input")[0];
                ine.focus();
                return;
            } else if (field == "expidate") {
                let ine = document
                    .getElementsByClassName("expidate")[index].getElementsByTagName("input")[0];
                ine.focus();
                return;
            }
            this.$refs[field] && this.$refs[field][index].focus();
        },

        handleClickCeShi() {
            this.DialogExtract = true;
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getWidth(e) {
            this.exWidth = e + "%";
        },

        getExtractName(e) {
            this.exTitle = e;
        },



        //取消新增
        cancelActionBox() {
            this.$confirm("将会清除改动的数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$common.delOrderInfo(this.sendDataInfo.psrgmId)
                    this.$emit("drawerCancel", 0);
                    this.initActionBox();
                    this.$refs["sendDataInfo"].resetFields();
                })
                .catch(() => { });
        },

        //确认新增
        async sendDataAction() {
            const index = this.filterTableData.findIndex(item => item.checkState != 2)
            if (index == -1) {
                this.sub()
            } else {
                return this.$message({
                    message: "未全部上架",
                    type: "error",
                });
            }
        },
        async sub() {
            const list = []
            this.filterTableData.forEach(item => {
                item.detailInfo.forEach(items => {
                    const info = {}
                    info.rgcadId = items.rgcadId
                    info.slId = items.slId
                    info.stId = items.stId
                    info.listingNum = items.listingNum
                    info.price = items.price
                    info.money = items.money
                    info.psprice = items.psprice
                    info.psmoney = items.psmoney
                    info.woadWcost = items.woadWcost
                    info.gross = items.gross
                    info.woadWcost = items.woadWcost
                    info.costMoney = items.costMoney
                    info.costPrice = items.costPrice
                    info.costAmount = items.costAmount
                    info.stName = items.stName
                    list.push(info)
                })
            })
            var responseData;
            if (this.dataActionBox.actionType == 0) {
                responseData = await this.$http.getSalesAdd({
                    'detailList': list,
                    'rgcamId': this.filterTableData[0].rgcamId
                }); //新增
            } else {
                responseData = await this.$http.getSalesAdd({
                    'detailList': list,
                    'rgcamId': this.filterTableData[0].rgcamId
                }); //修改
            }
            if (responseData.status == 200) {
                this.$refs["sendDataInfo"].resetFields();
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.$emit("drawerCancel", 1);
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        //删除货单
        deleteDetails(index) {
            this.sendDataInfo.pschaDetails.splice(index, 1);
        },
        // 校验所有数量是否等于总数量
        checkNum() {
        },
        //添加批号
        addNewBatch() {
            if (this.pschacBatchDetails.length > 0 && this.pschacBatchDetails.findIndex(item => item.listingNum == '') != -1) {
                return this.$message.error('请完善上架数量后再新增明细')
            } else if (this.filterTableData[this.selectedDetailsIndex].checkState == 2) {
                return this.$message.error('已全部上架')
            } else {
                this.addPschacBatch();
            }
        },
        //删除批号
        delOldBatch() {
            if (this.pschacBatchDetails.length > 1) {
                this.$confirm('确定删除此条明细吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.pschacBatchDetails.splice(this.selectedBatchnoIndex, 1);
                    this.sendDataInfo.pschaDetails[this.rowindex]["pschacBatchDetails"].splice(this.selectedBatchnoIndex, 1)
                    this.filterTableData[this.rowindex]["pschacBatchDetails"].splice(this.selectedBatchnoIndex, 1)
                    this.filterTableData[this.selectedDetailsIndex]["detailInfo"].splice(this.selectedBatchnoIndex, 1)
                    this.selectedBatchnoIndex--;
                    // this.sureUp()
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                }).catch(() => { });
            } else {
                this.$message({
                    message: "请输入合理信息, 至少保留一项",
                    type: "error",
                });
                return false;
            }
            console.log("del");
        },
        addPschacBatch(reset) {
            const num = this.pschacBatchDetails && this.pschacBatchDetails.length > 0 ? this.pschacBatchDetails.reduce((prev, item) => {
                prev += +item.listingNum
                return prev
            }, 0) : 0
            const totalNum = +this.filterTableData[this.selectedDetailsIndex].rgcadRefnumber + +this.filterTableData[this.selectedDetailsIndex].rgcadQuanumber
            const info = { ...this.filterTableData[this.selectedDetailsIndex] }
            if (totalNum == num) return
            this.pschacBatchDetails.push({
                ...info,
                listingNum: '',
                stId: this.bachDialogTitle.stId ? this.bachDialogTitle.stId : "",
            });
            this.$set(this.pschacBatchDetails[this.pschacBatchDetails.length - 1], 'listingNum', totalNum - num)
            this.$nextTick(() => {
                this.changeListingNum(this.pschacBatchDetails.length - 1)
                this.selectedBatchnoIndex = this.pschacBatchDetails.length - 1
                this.tableNextFocus('slCode', this.pschacBatchDetails.length - 1)
            })
        },
        // 验收人验证
        async userVerification() {
            var pscadSeccherObj = {
                opmAccount: this.reviewUserInfo.selectIndex,
                passWord: this.reviewUserInfo.passWord,
            };

            let res = await this.$http.reviewVerification(pscadSeccherObj);
            if (res.status == 200) {
                this.reviewUserInfo.selectIndex = res.result.opmName
                this.dialogFormVisible = false;
                this.sendDataInfo.pscadSeccher = res.result.opmId;
                this.sendDataInfo.pscadSeccherName =
                    res.result.opmName;
            } else {
                this.$message({
                    message: res.message,
                    type: "error",
                });
            }
        },

        // 获取验收人
        async getSpecialUserTwo() {
            let responseData = await this.$http.getSpecialUser({
                opmAcceptor: 1
            });
            if (responseData.status == 200) {
                this.userTwoList = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 获取供货员
        async getSpecialUser() {
            let responseData = await this.$http.getSpecialUser({
                opmBuyer: 1
            });
            if (responseData.status == 200) {
                this.userOneList = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 获取所有可用库房列表
        async getAllStorageRoom() {
            let responseData = await this.$http.getAllStorageRoom();
            if (responseData.status == 200) {
                this.storageRoomList = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        //获取选择库房
        getSelectStorageRoom(roomId) {
            for (let i = 0; i < this.storageRoomList.length; i++) {
                const item = this.storageRoomList[i];
                if (item.stId == roomId) {
                    return item.stName;
                }
            }
            return "无";
        },

        //初始化操作
        initActionBox() {
            for (let key in this.sendDataInfo) {
                if (key == "pschaDetails") {
                    this.sendDataInfo[key] = [];
                } else {
                    this.sendDataInfo[key] = "";
                }
            }
            this.sendDataInfo.pschaDetails = [];
            this.filterTableData = [];
            this.sendDataInfo.totalMoney = 0;
            this.sendDataInfo.totalNumber = 0;
            this.sendDataInfo.totalCount = 0;
        },
        //接收父组件传值
        openBox() {
            console.log(this.actionData);
            this.dataActionBox.actionType = this.actionData.cate;
            this.formDataList = this.actionData.formData;
            this.filterMainField();
            var oldData = this.actionData.oldData;
            this.showTabs = this.actionData.formData[0].jciName;
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = "新增信息";
                this.dataActionBox.openMode = "ltr";
            } else if (this.dataActionBox.actionType == 1) {
                this.dataActionBox.boxTitle = "编辑信息";
                this.dataActionBox.openMode = "rtl";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key])
                    if (key == "pschaDetails") {
                        for (const key1 in dataInfo[key]) {
                            console.log(key1);
                            this.$set(this.filterTableData, key1, dataInfo[key][key1])
                        }
                    }
                }
                this.sendDataInfo.pschaDetails.forEach((v, i) => {
                    v.in = i;
                });
                this.filterTableData = this.sendDataInfo.pschaDetails || [];
                if (this.filterTableData && this.filterTableData.length > 0) {
                    this.filterTableData.forEach(item => {
                        item.checkState = 2
                    })
                    this.$nextTick(() => {
                        this.nextFocus(this.seIndex);
                        this.selectedDetailsIndex = 0
                        setTimeout(() => {
                            let refsElTable = this.$refs.mxTableRef
                            refsElTable.clearSelection();
                            refsElTable.toggleRowSelection(this.filterTableData[this.selectedDetailsIndex]);
                            this.msgCellClick(this.filterTableData[this.selectedDetailsIndex])
                        }, 16.7)
                    });
                }
            } else {
                this.dataActionBox.boxTitle = "查看信息";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.sendDataInfo[key] = dataInfo[key];
                    if (key == "pschaDetails") this.filterTableData = dataInfo[key];
                }
                this.filterTableData = dataInfo.detailList

                if (this.filterTableData && this.filterTableData.length > 0) {
                    this.filterTableData.forEach(item => {
                        item.checkState = 2
                        item.detailInfo = [...item.listingList]
                    })
                    this.pschacBatchDetails = [...this.filterTableData[0].detailInfo]
                    this.$nextTick(() => {
                        this.nextFocus(this.seIndex);
                        this.selectedDetailsIndex = 0
                        setTimeout(() => {
                            let refsElTable = this.$refs.mxTableRef
                            refsElTable.clearSelection();
                            refsElTable.toggleRowSelection(this.filterTableData[this.selectedDetailsIndex]);
                            // this.msgCellClick(this.filterTableData[this.selectedDetailsIndex])
                        }, 16.7)
                    });
                }
            }
            this.getHeight()
        },
        getHeight() {
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight()
                    } else {
                        this.$refs['tree'].init(this.sendDataInfo.slimId)
                        this.mxHeight = this.$common.getHeight()
                    }
                }, 100)
                this.initFocus();
            });
        },
        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = [];
            var mxFormList = [];
            this.formDataList.forEach((item) => {
                if (item.jciType == 1) {
                    mainFormList.push(item);
                } else if (item.jciType == 2) {
                    mxFormList.push(item);

                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
                }
            });
            this.mxForm = mxFormList[0].jurconfigform;
            this.phForm = mxFormList[1].jurconfigform;
            this.phForm.forEach(item => {
                if (item.focusField == 'keydown') {
                    this.keydownField = item.entityField
                }
            })
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key));
                this.tabForm[i].jurconfigform = [];
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    if (key.jurconfigform[index].isShow == 1)
                        this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
                }
            });
            var arr = [{ entityField: "pschaDetails" }]
            var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key])
            }
            this.filterTableData = []
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.openBox();
        this.getSpecialUser();
        this.getSpecialUserTwo();
        this.getAllStorageRoom();
        this.$dbCache.Record_Get(9).then((res) => {//采购验收必须要填写抽检数量校验
            //抽检数量拦截
            let obj = res
            if (obj.isEnable && obj.isEnable == 1) this.detailRules1 = true;
        });
        this.$dbCache.Record_Get(11).then((res) => {//采购特殊药品必须要填写第二验收人
            //第二验收拦截
            let obj = res
            if (obj.isEnable && obj.isEnable == 1) this.detailRules2 = true;
        });
        this.getTimestamp()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.ppId = "rgcamId";
        addEventListener('keyup', this.keyUp)//创建监听键盘事件
        addEventListener('keyup', this.keyUpEnter)//创建监听键盘事件
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.getMainInput();
    }, //生命周期 - 更新之后
    beforeDestroy() {
        removeEventListener('keyup', this.keyUp)
        removeEventListener('keyup', this.keyUpEnter)
    }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    /* height: 500px !important; */
    overflow-y: auto;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
    /* padding-right: 20px; */
}

.pihaoDialog .el-dialog {
    min-height: 60%;
}

.el-drawer {
    outline: none;
}

#dia .el-date-editor.el-input,
#dia .el-date-editor.el-input__inner {
    width: 100% !important;
}

::v-deep .el-input.is-disabled .el-input__inner,
::v-deep .el-textarea.is-disabled .el-textarea__inner {
    background-color: #fff;
    color: #333;
}

::v-deep
    .el-radio-button__orig-radio:disabled:checked
    + .el-radio-button__inner {
    background-color: #ccc;
}

::v-deep .el-radio-button__orig-radio:disabled + .el-radio-button__inner {
    color: #333;
}
</style>